/* KEIKA 共通ヘッダー ─ 全ページで唯一の定義。
 * ここを直せば PC/SP・トップ/コンセプト すべてに反映されます。
 * 各ページの bundle 内のヘッダーは、この 2 つに委譲するだけのスタブです。
 * 読み込み順: support.js → keika-header.bundle.js → 各ページ bundle
 */
(function () {
  /* React は描画時に解決する(読み込み順に依存しないよう遅延参照) */
  var React = new Proxy({}, { get: function (_, k) { return window.React[k]; } });

const __venc_KEIKAHeaderPC = v => String(v).replace(/[%|=]/g, encodeURIComponent);
const __vkey_KEIKAHeaderPC = p => "prop=" + __venc_KEIKAHeaderPC(p.prop);
function KEIKAHeaderPC(_p = {}) {
  const props = {
    ..._p,
    prop: _p.prop ?? "default"
  };
  const __body0 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 1440,
      height: 90,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 90
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 622.421,
      top: 31.312,
      width: 200.579,
      height: 35.375,
      overflow: "hidden",
      cursor: "pointer"
    },
    role: "link",
    "aria-label": "KEiKA トップページ",
    onClick: function () { window.location.href = "/"; }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 3.430,
    height: 34.341,
    viewBox: "0 0 3.430 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 95.512,
      top: 0.286,
      width: 3.43,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 27.638,
    height: 33.879,
    viewBox: "0 0 27.638 33.879",
    fill: "none",
    style: {
      position: "absolute",
      left: 51.232,
      top: 0.748,
      width: 27.638,
      height: 33.879,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.006 33.879 L 0.006 0 L 27.237 0 L 27.237 3.151 L 3.455 3.151 L 3.455 15.139 L 23.6 15.139 L 23.6 18.235 L 3.455 18.235 L 3.455 30.728 L 27.638 30.728 L 27.638 33.879 L 0 33.879 L 0.006 33.879 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.446,
    height: 35.375,
    viewBox: "0 0 36.446 35.375",
    fill: "none",
    style: {
      position: "absolute",
      left: 164.133,
      top: 0,
      width: 36.446,
      height: 35.375,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.446 35.375 L 20.558 0 L 15.79 0 L 0 35.375 L 4.008 35.375 L 7.785 26.805 L 9.659 22.432 C 20.291 21.775 28.952 28.131 31.343 33.295 L 32.249 35.375 L 36.44 35.375 L 36.446 35.375 Z M 16.471 6.788 C 17.238 4.988 17.651 3.923 18.113 2.171 C 18.472 3.759 18.782 4.72 19.701 6.788 L 26.057 21.264 L 27.651 24.834 C 22.608 21.915 14.391 20.881 10.206 21.191 L 16.477 6.788 L 16.471 6.788 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.525,
    height: 34.341,
    viewBox: "0 0 36.525 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.286,
      width: 36.525,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.716 11.532 C 19.093 6.77 26.16 3.868 33.891 3.868 L 33.891 0.462 C 20.522 0.462 6.198 11.295 3.43 24.263 L 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 33.903 C 3.54 26.233 6.49 19.245 11.277 13.941 L 31.677 34.341 L 36.525 34.341 L 13.716 11.532 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.525,
    height: 34.341,
    viewBox: "0 0 36.525 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 120.48,
      top: 0.286,
      width: 36.525,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.716 11.532 C 19.093 6.77 26.16 3.868 33.891 3.868 L 33.891 0.462 C 20.522 0.462 6.198 11.295 3.43 24.263 L 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 33.903 C 3.54 26.233 6.49 19.245 11.277 13.941 L 31.677 34.341 L 36.525 34.341 L 13.716 11.532 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1213,
      top: 42,
      width: 98,
      height: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 7.5,
      top: -11.5,
      width: 20,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 10.353,
    height: 10.498,
    viewBox: "0 0 10.353 10.498",
    fill: "none",
    style: {
      position: "absolute",
      left: 5.024,
      top: 0,
      width: 10.353,
      height: 10.498,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.176 10.498 C 8.033 10.498 10.353 8.146 10.353 5.249 C 10.353 2.352 8.026 0 5.176 0 C 2.326 0 0 2.352 0 5.249 C 0 8.146 2.319 10.498 5.176 10.498 Z M 5.176 1.474 C 7.226 1.474 8.899 3.17 8.899 5.249 C 8.899 7.328 7.226 9.023 5.176 9.023 C 3.126 9.023 1.454 7.328 1.454 5.249 C 1.454 3.17 3.126 1.474 5.176 1.474 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20,
    height: 7.202,
    viewBox: "0 0 20 7.202",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 12.798,
      width: 20,
      height: 7.202,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.927 6.391 C 19.927 6.325 19.753 4.711 18.401 3.118 C 17.186 1.696 14.751 0 10.004 0 C 5.256 0 2.814 1.696 1.607 3.118 C 0.247 4.711 0.08 6.325 0.08 6.391 L 0 7.202 L 20 7.202 L 19.92 6.391 L 19.927 6.391 Z M 10.004 5.728 L 1.73 5.728 C 2.246 4.29 4.028 1.482 10.004 1.482 C 15.98 1.482 17.761 4.298 18.277 5.728 L 10.004 5.728 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 3,
      top: 13,
      width: 29,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text1 ?? "Login"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 66,
      top: 13,
      width: 25,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text2 ?? "Cart "), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 64,
      top: -10,
      width: 23,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 55,
      top: 37,
      display: "flex",
      flexDirection: "row",
      gap: 72,
      alignItems: "center",
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0, cursor: "pointer" }, role: "link", tabIndex: 0, onClick: function () { window.location.href = "/collections/all"; }, onKeyDown: function (e) { if (e.key === "Enter") window.location.href = "/collections/all"; } }, props.text3 ?? "Products"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0, cursor: "pointer" }, role: "link", tabIndex: 0, onClick: function () { window.location.href = "/pages/ingredients"; }, onKeyDown: function (e) { if (e.key === "Enter") window.location.href = "/pages/ingredients"; } }, props.text4 ?? "Ingredientslist"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0, cursor: "pointer" }, role: "link", tabIndex: 0, onClick: function () { window.location.href = "/pages/news"; }, onKeyDown: function (e) { if (e.key === "Enter") window.location.href = "/pages/news"; } }, "News")), /*#__PURE__*/React.createElement("div", {
    id: "keika-hamburger",
    style: {
      position: "absolute",
      left: 1340,
      top: 48,
      width: 50,
      height: 28,
      overflow: "visible",
      cursor: "pointer",
      padding: 7,
      margin: -7
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1.300,
    viewBox: "0 -0.650 50 1.300",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 50,
      height: 1.2999999523162842,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.65 L 0 0 L 50 0 L 50 -0.65 L 50 -1.3 L 0 -1.3 L 0 -0.65 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1.300,
    viewBox: "0 -0.650 50 1.300",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 14,
      width: 50,
      height: 1.2999999523162842,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.65 L 0 0 L 50 0 L 50 -0.65 L 50 -1.3 L 0 -1.3 L 0 -0.65 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
  const __body1 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 1440,
      height: 90,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 1440,
      height: 90,
      backgroundColor: "rgb(249,249,249)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 89,
      width: 1440,
      height: 1,
      backgroundColor: "rgb(42,43,45)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 622.421,
      top: 31.312,
      width: 200.579,
      height: 35.375,
      overflow: "hidden",
      cursor: "pointer"
    },
    role: "link",
    "aria-label": "KEiKA トップページ",
    onClick: function () { window.location.href = "/"; }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 3.430,
    height: 34.341,
    viewBox: "0 0 3.430 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 95.512,
      top: 0.286,
      width: 3.43,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 27.638,
    height: 33.879,
    viewBox: "0 0 27.638 33.879",
    fill: "none",
    style: {
      position: "absolute",
      left: 51.232,
      top: 0.748,
      width: 27.638,
      height: 33.879,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.006 33.879 L 0.006 0 L 27.237 0 L 27.237 3.151 L 3.455 3.151 L 3.455 15.139 L 23.6 15.139 L 23.6 18.235 L 3.455 18.235 L 3.455 30.728 L 27.638 30.728 L 27.638 33.879 L 0 33.879 L 0.006 33.879 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.446,
    height: 35.375,
    viewBox: "0 0 36.446 35.375",
    fill: "none",
    style: {
      position: "absolute",
      left: 164.133,
      top: 0,
      width: 36.446,
      height: 35.375,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.446 35.375 L 20.558 0 L 15.79 0 L 0 35.375 L 4.008 35.375 L 7.785 26.805 L 9.659 22.432 C 20.291 21.775 28.952 28.131 31.343 33.295 L 32.249 35.375 L 36.44 35.375 L 36.446 35.375 Z M 16.471 6.788 C 17.238 4.988 17.651 3.923 18.113 2.171 C 18.472 3.759 18.782 4.72 19.701 6.788 L 26.057 21.264 L 27.651 24.834 C 22.608 21.915 14.391 20.881 10.206 21.191 L 16.477 6.788 L 16.471 6.788 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.525,
    height: 34.341,
    viewBox: "0 0 36.525 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.286,
      width: 36.525,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.716 11.532 C 19.093 6.77 26.16 3.868 33.891 3.868 L 33.891 0.462 C 20.522 0.462 6.198 11.295 3.43 24.263 L 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 33.903 C 3.54 26.233 6.49 19.245 11.277 13.941 L 31.677 34.341 L 36.525 34.341 L 13.716 11.532 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 36.525,
    height: 34.341,
    viewBox: "0 0 36.525 34.341",
    fill: "none",
    style: {
      position: "absolute",
      left: 120.48,
      top: 0.286,
      width: 36.525,
      height: 34.341,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.716 11.532 C 19.093 6.77 26.16 3.868 33.891 3.868 L 33.891 0.462 C 20.522 0.462 6.198 11.295 3.43 24.263 L 3.43 0 L 0 0 L 0 34.341 L 3.43 34.341 L 3.43 33.903 C 3.54 26.233 6.49 19.245 11.277 13.941 L 31.677 34.341 L 36.525 34.341 L 13.716 11.532 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 55,
      top: 37,
      display: "flex",
      flexDirection: "row",
      gap: 72,
      alignItems: "center",
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, props.text1 ?? "Products"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, props.text2 ?? "Ingredientslist"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative",
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.080em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase",
      flexShrink: 0
    }
  }, props.text3 ?? "News")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1340,
      top: 40,
      width: 50,
      height: 14,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1.300,
    viewBox: "0 -0.650 50 1.300",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 50,
      height: 1.2999999523162842,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.65 L 0 0 L 50 0 L 50 -0.65 L 50 -1.3 L 0 -1.3 L 0 -0.65 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1.300,
    viewBox: "0 -0.650 50 1.300",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 14,
      width: 50,
      height: 1.2999999523162842,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.65 L 0 0 L 50 0 L 50 -0.65 L 50 -1.3 L 0 -1.3 L 0 -0.65 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1213,
      top: 42,
      width: 98,
      height: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 7.5,
      top: -11.5,
      width: 20,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 10.353,
    height: 10.498,
    viewBox: "0 0 10.353 10.498",
    fill: "none",
    style: {
      position: "absolute",
      left: 5.024,
      top: 0,
      width: 10.353,
      height: 10.498,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.176 10.498 C 8.033 10.498 10.353 8.146 10.353 5.249 C 10.353 2.352 8.026 0 5.176 0 C 2.326 0 0 2.352 0 5.249 C 0 8.146 2.319 10.498 5.176 10.498 Z M 5.176 1.474 C 7.226 1.474 8.899 3.17 8.899 5.249 C 8.899 7.328 7.226 9.023 5.176 9.023 C 3.126 9.023 1.454 7.328 1.454 5.249 C 1.454 3.17 3.126 1.474 5.176 1.474 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20,
    height: 7.202,
    viewBox: "0 0 20 7.202",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 12.798,
      width: 20,
      height: 7.202,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.927 6.391 C 19.927 6.325 19.753 4.711 18.401 3.118 C 17.186 1.696 14.751 0 10.004 0 C 5.256 0 2.814 1.696 1.607 3.118 C 0.247 4.711 0.08 6.325 0.08 6.391 L 0 7.202 L 20 7.202 L 19.92 6.391 L 19.927 6.391 Z M 10.004 5.728 L 1.73 5.728 C 2.246 4.29 4.028 1.482 10.004 1.482 C 15.98 1.482 17.761 4.298 18.277 5.728 L 10.004 5.728 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 3,
      top: 13,
      width: 29,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text4 ?? "Login"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 66,
      top: 13,
      width: 25,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, "Cart "), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 64,
      top: -10,
      width: 23,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
  const __impls = {
    // figma: プロパティ1=Default
    "prop=default": __body0,
    // figma: プロパティ1=バリアント2
    "prop=バリアント2": __body1
  };
  return (__impls[__vkey_KEIKAHeaderPC(props)] ?? __body0)();
}

const __venc_KEIKAHeaderSP = v => String(v).replace(/[%|=]/g, encodeURIComponent);
const __vkey_KEIKAHeaderSP = p => "prop=" + __venc_KEIKAHeaderSP(p.prop);
function KEIKAHeaderSP(_p = {}) {
  const props = {
    ..._p,
    prop: _p.prop ?? "デフォルト"
  };
  const __body0 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 390,
      height: 60,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 60
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 137,
      top: 21,
      width: 115.071,
      height: 20.295,
      overflow: "hidden",
      cursor: "pointer"
    },
    role: "link",
    "aria-label": "KEiKA トップページ",
    onClick: function () { window.location.href = "/"; }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 1.968,
    height: 19.701,
    viewBox: "0 0 1.968 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 54.794,
      top: 0.164,
      width: 1.968,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 15.856,
    height: 19.436,
    viewBox: "0 0 15.856 19.436",
    fill: "none",
    style: {
      position: "absolute",
      left: 29.392,
      top: 0.429,
      width: 15.856,
      height: 19.436,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.003 19.436 L 0.003 0 L 15.626 0 L 15.626 1.808 L 1.982 1.808 L 1.982 8.685 L 13.539 8.685 L 13.539 10.461 L 1.982 10.461 L 1.982 17.629 L 15.856 17.629 L 15.856 19.436 L 0 19.436 L 0.003 19.436 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.909,
    height: 20.295,
    viewBox: "0 0 20.909 20.295",
    fill: "none",
    style: {
      position: "absolute",
      left: 94.162,
      top: 0,
      width: 20.909,
      height: 20.295,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.909 20.295 L 11.794 0 L 9.059 0 L 0 20.295 L 2.3 20.295 L 4.466 15.378 L 5.541 12.869 C 11.641 12.492 16.61 16.139 17.981 19.101 L 18.501 20.295 L 20.905 20.295 L 20.909 20.295 Z M 9.449 3.894 C 9.889 2.861 10.126 2.251 10.392 1.246 C 10.597 2.156 10.775 2.708 11.302 3.894 L 14.949 12.199 L 15.863 14.247 C 12.97 12.572 8.256 11.979 5.855 12.157 L 9.453 3.894 L 9.449 3.894 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.954,
    height: 19.701,
    viewBox: "0 0 20.954 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.164,
      width: 20.954,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.869 6.616 C 10.953 3.884 15.008 2.219 19.443 2.219 L 19.443 0.265 C 11.773 0.265 3.556 6.48 1.968 13.919 L 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 19.45 C 2.031 15.05 3.723 11.041 6.469 7.998 L 18.173 19.701 L 20.954 19.701 L 7.869 6.616 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.954,
    height: 19.701,
    viewBox: "0 0 20.954 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 69.119,
      top: 0.164,
      width: 20.954,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.869 6.616 C 10.953 3.884 15.008 2.219 19.443 2.219 L 19.443 0.265 C 11.773 0.265 3.556 6.48 1.968 13.919 L 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 19.45 C 2.031 15.05 3.723 11.041 6.469 7.998 L 18.173 19.701 L 20.954 19.701 L 7.869 6.616 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "keika-sp-ham",
    style: {
      position: "absolute",
      left: 19,
      top: 22,
      width: 50,
      height: 20,
      overflow: "visible",
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1,
    viewBox: "0 -0.500 50 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 50,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 50 0 L 50 -0.5 L 50 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1,
    viewBox: "0 -0.500 50 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 14,
      width: 50,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 50 0 L 50 -0.5 L 50 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 296,
      top: 26,
      width: 98,
      height: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: -8,
      top: -11.5,
      width: 29,
      height: 34.5,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 4.5,
      top: 0,
      width: 20,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 10.353,
    height: 10.498,
    viewBox: "0 0 10.353 10.498",
    fill: "none",
    style: {
      position: "absolute",
      left: 5.024,
      top: 0,
      width: 10.353,
      height: 10.498,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.176 10.498 C 8.033 10.498 10.353 8.146 10.353 5.249 C 10.353 2.352 8.026 0 5.176 0 C 2.326 0 0 2.352 0 5.249 C 0 8.146 2.319 10.498 5.176 10.498 Z M 5.176 1.474 C 7.226 1.474 8.899 3.17 8.899 5.249 C 8.899 7.328 7.226 9.023 5.176 9.023 C 3.126 9.023 1.454 7.328 1.454 5.249 C 1.454 3.17 3.126 1.474 5.176 1.474 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20,
    height: 7.202,
    viewBox: "0 0 20 7.202",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 12.798,
      width: 20,
      height: 7.202,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.927 6.391 C 19.927 6.325 19.753 4.711 18.401 3.118 C 17.186 1.696 14.751 0 10.004 0 C 5.256 0 2.814 1.696 1.607 3.118 C 0.247 4.711 0.08 6.325 0.08 6.391 L 0 7.202 L 20 7.202 L 19.92 6.391 L 19.927 6.391 Z M 10.004 5.728 L 1.73 5.728 C 2.246 4.29 4.028 1.482 10.004 1.482 C 15.98 1.482 17.761 4.298 18.277 5.728 L 10.004 5.728 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 24.5,
      width: 29,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text1 ?? "Login")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 42,
      top: -10,
      width: 26,
      height: 33,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 1,
      top: 23,
      width: 25,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text2 ?? "Cart "), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 23,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(37,23,20)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(37,23,20)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(37,23,20)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
  const __body1 = () => /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: {
      width: 390,
      height: 60,
      position: "relative",
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 390,
      height: 60,
      backgroundColor: "rgb(249,249,249)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 60,
      width: 390,
      height: 1,
      backgroundColor: "rgb(42,43,45)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 137,
      top: 21,
      width: 115.071,
      height: 20.295,
      overflow: "hidden",
      cursor: "pointer"
    },
    role: "link",
    "aria-label": "KEiKA トップページ",
    onClick: function () { window.location.href = "/"; }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 1.968,
    height: 19.701,
    viewBox: "0 0 1.968 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 54.794,
      top: 0.164,
      width: 1.968,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 15.856,
    height: 19.436,
    viewBox: "0 0 15.856 19.436",
    fill: "none",
    style: {
      position: "absolute",
      left: 29.392,
      top: 0.429,
      width: 15.856,
      height: 19.436,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.003 19.436 L 0.003 0 L 15.626 0 L 15.626 1.808 L 1.982 1.808 L 1.982 8.685 L 13.539 8.685 L 13.539 10.461 L 1.982 10.461 L 1.982 17.629 L 15.856 17.629 L 15.856 19.436 L 0 19.436 L 0.003 19.436 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.909,
    height: 20.295,
    viewBox: "0 0 20.909 20.295",
    fill: "none",
    style: {
      position: "absolute",
      left: 94.162,
      top: 0,
      width: 20.909,
      height: 20.295,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.909 20.295 L 11.794 0 L 9.059 0 L 0 20.295 L 2.3 20.295 L 4.466 15.378 L 5.541 12.869 C 11.641 12.492 16.61 16.139 17.981 19.101 L 18.501 20.295 L 20.905 20.295 L 20.909 20.295 Z M 9.449 3.894 C 9.889 2.861 10.126 2.251 10.392 1.246 C 10.597 2.156 10.775 2.708 11.302 3.894 L 14.949 12.199 L 15.863 14.247 C 12.97 12.572 8.256 11.979 5.855 12.157 L 9.453 3.894 L 9.449 3.894 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.954,
    height: 19.701,
    viewBox: "0 0 20.954 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0.164,
      width: 20.954,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.869 6.616 C 10.953 3.884 15.008 2.219 19.443 2.219 L 19.443 0.265 C 11.773 0.265 3.556 6.48 1.968 13.919 L 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 19.45 C 2.031 15.05 3.723 11.041 6.469 7.998 L 18.173 19.701 L 20.954 19.701 L 7.869 6.616 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20.954,
    height: 19.701,
    viewBox: "0 0 20.954 19.701",
    fill: "none",
    style: {
      position: "absolute",
      left: 69.119,
      top: 0.164,
      width: 20.954,
      height: 19.701,
      color: "rgb(4,0,0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.869 6.616 C 10.953 3.884 15.008 2.219 19.443 2.219 L 19.443 0.265 C 11.773 0.265 3.556 6.48 1.968 13.919 L 1.968 0 L 0 0 L 0 19.701 L 1.968 19.701 L 1.968 19.45 C 2.031 15.05 3.723 11.041 6.469 7.998 L 18.173 19.701 L 20.954 19.701 L 7.869 6.616 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 19,
      top: 24,
      width: 50,
      height: 14,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1,
    viewBox: "0 -0.500 50 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 50,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 50 0 L 50 -0.5 L 50 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 50,
    height: 1,
    viewBox: "0 -0.500 50 1",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 14,
      width: 50,
      height: 1,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.5 L 0 0 L 50 0 L 50 -0.5 L 50 -1 L 0 -1 L 0 -0.5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 296,
      top: 26,
      width: 98,
      height: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: -8,
      top: -11.5,
      width: 29,
      height: 34.5,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 4.5,
      top: 0,
      width: 20,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 10.353,
    height: 10.498,
    viewBox: "0 0 10.353 10.498",
    fill: "none",
    style: {
      position: "absolute",
      left: 5.024,
      top: 0,
      width: 10.353,
      height: 10.498,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.176 10.498 C 8.033 10.498 10.353 8.146 10.353 5.249 C 10.353 2.352 8.026 0 5.176 0 C 2.326 0 0 2.352 0 5.249 C 0 8.146 2.319 10.498 5.176 10.498 Z M 5.176 1.474 C 7.226 1.474 8.899 3.17 8.899 5.249 C 8.899 7.328 7.226 9.023 5.176 9.023 C 3.126 9.023 1.454 7.328 1.454 5.249 C 1.454 3.17 3.126 1.474 5.176 1.474 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 20,
    height: 7.202,
    viewBox: "0 0 20 7.202",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 12.798,
      width: 20,
      height: 7.202,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.927 6.391 C 19.927 6.325 19.753 4.711 18.401 3.118 C 17.186 1.696 14.751 0 10.004 0 C 5.256 0 2.814 1.696 1.607 3.118 C 0.247 4.711 0.08 6.325 0.08 6.391 L 0 7.202 L 20 7.202 L 19.92 6.391 L 19.927 6.391 Z M 10.004 5.728 L 1.73 5.728 C 2.246 4.29 4.028 1.482 10.004 1.482 C 15.98 1.482 17.761 4.298 18.277 5.728 L 10.004 5.728 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 0,
      top: 24.5,
      width: 29,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text1 ?? "Login")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 42,
      top: -10,
      width: 26,
      height: 33,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 1,
      top: 23,
      width: 25,
      height: 10,
      fontFamily: "Marcellus, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 8,
      whiteSpace: "nowrap",
      lineHeight: "100%",
      letterSpacing: "0.150em",
      color: "rgb(42,43,45)",
      textTransform: "uppercase"
    }
  }, props.text2 ?? "Cart "), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 23,
      height: 20,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(37,23,20)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(37,23,20)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(37,23,20)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 22.994,
    height: 16.041,
    viewBox: "0 0 22.994 16.041",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 22.994,
      height: 16.041,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.783 4.734 C 22.601 4.523 22.341 4.403 22.058 4.403 L 6.536 4.424 L 5.558 0 L 0 0 L 0 1.409 L 4.384 1.409 L 7.471 15.343 C 7.572 15.752 7.949 16.041 8.384 16.041 L 20.123 16.041 C 20.551 16.041 20.928 15.759 21.043 15.315 L 22.978 5.495 C 23.029 5.227 22.957 4.952 22.775 4.741 L 22.783 4.734 Z M 19.71 14.632 L 8.804 14.632 L 6.855 5.826 L 21.457 5.805 L 19.717 14.625 L 19.71 14.632 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 7.971,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 2.464,
    height: 2.395,
    viewBox: "0 0 2.464 2.395",
    fill: "none",
    style: {
      position: "absolute",
      left: 17.877,
      top: 17.612,
      width: 2.464,
      height: 2.395,
      color: "rgb(42,43,45)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.232 0 C 0.551 0 0 0.535 0 1.198 C 0 1.86 0.551 2.395 1.232 2.395 C 1.913 2.395 2.464 1.86 2.464 1.198 C 2.464 0.535 1.913 0 1.232 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
  const __impls = {
    // figma: プロパティ1=デフォルト
    "prop=デフォルト": __body0,
    // figma: プロパティ1=バリアント2
    "prop=バリアント2": __body1
  };
  return (__impls[__vkey_KEIKAHeaderSP(props)] ?? __body0)();
}


  /* ===== iOS ステータスバー(時刻/電波/バッテリー)を全ページで非表示 =====
   * SPキャンバス最上部に焼き込まれた 47px の帯を消し、下を詰める。
   * この部分は今後どのページでも表示しない。 */
  window.KEIKA_SP_TRIM = 0;
  function trimStatusBars() {
    var frames = Array.prototype.filter.call(document.querySelectorAll("div"), function (d) {
      return d.style.width === "390px" && parseFloat(d.style.height) > 2000;
    });
    if (!frames.length) return false;
    var did = false;
    frames.forEach(function (frame) {
      if (frame.dataset.statusTrimmed) { did = true; return; }
      var kids = Array.prototype.slice.call(frame.children);
      var bar = kids.filter(function (k) {
        var t = parseFloat(k.style.top), h = parseFloat(k.style.height);
        return t === 0 && h >= 40 && h <= 50 && !(k.textContent || "").trim();
      })[0];
      if (!bar) return;
      var h = parseFloat(bar.style.height);
      frame.dataset.statusTrimmed = "1";
      bar.style.display = "none";
      kids.forEach(function (k) {
        var t = parseFloat(k.style.top);
        if (k !== bar && !isNaN(t) && t >= h) k.style.top = (t - h) + "px";
      });
      var H = parseFloat(frame.style.height);
      frame.style.height = (H - h) + "px";
      window.KEIKA_SP_TRIM = h;
      did = true;
      window.dispatchEvent(new Event("resize"));
    });
    return did;
  }
  var stTries = 0;
  var stIv = setInterval(function () {
    if (trimStatusBars() || ++stTries > 80) clearInterval(stIv);
  }, 150);


  /* ===== 共通ニュース帯 ─ トップのものを唯一の定義として全ページで使用 =====
   * KEIKANewsPC (1440x40) / KEIKANewsSP (390x45)
   * 文言・色・速度はここだけ直せば全ページ・PC/SP に反映されます。 */
  var KEIKA_NEWS_TEXT = "\u5b9a\u671f\u8cfc\u5165\u7d99\u7d9a\u738790\uff05\u8d85\u3048\uff01\u30c8\u30a5\u30a4\u30f3\u30af\u30eb\u30f4\u30a3\u30f4\u30a3\u3000\u30df\u30cb\u30dc\u30c8\u30eb\u8ca9\u58f2\u4e2d\uff01";
  var KEIKA_NEWS_FONT = "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif";

  function KEIKANewsPC(p) {
    p = p || {};
    return React.createElement("div", {
      className: p.className,
      style: Object.assign({ width: 1440, height: 40, position: "relative", overflow: "hidden", backgroundColor: "rgb(42,43,45)" }, p.style)
    }, React.createElement("span", {
      style: {
        position: "absolute", left: 513, top: 11, width: 415, height: 17,
        fontFamily: KEIKA_NEWS_FONT, fontWeight: 400, fontSize: 12,
        whiteSpace: "nowrap", lineHeight: "100%", letterSpacing: "0.080em",
        color: "rgb(249,249,249)"
      }
    }, p.text ?? KEIKA_NEWS_TEXT));
  }

  /* bare: キャンバス側に既に黒帯がある場合は流れる文字だけを描画 */
  function KEIKANewsSP(p) {
    p = p || {};
    var bare = !!p.bare;
    return React.createElement("div", {
      className: p.className,
      style: Object.assign(bare
        ? { width: 366, height: 18, position: "relative", overflow: "hidden" }
        : { width: 390, height: 45, position: "relative", overflow: "hidden", backgroundColor: "rgb(42,43,45)" }, p.style)
    }, React.createElement("span", {
      className: "keika-sp-marquee",
      style: {
        position: "absolute", left: bare ? 0 : 12, top: bare ? 1 : 14, width: 839, height: 17,
        fontFamily: KEIKA_NEWS_FONT, fontWeight: 400, fontSize: 12,
        whiteSpace: "nowrap", lineHeight: "100%", letterSpacing: "0.080em",
        color: "rgb(249,249,249)"
      }
    }, p.text ?? (KEIKA_NEWS_TEXT + "  " + KEIKA_NEWS_TEXT)));
  }

  /* ヘッダーの LOGIN / CART と、メニュー内のボタンをリンク化する。
   * アイコンとラベルをまとめて覆う透明な <a> を重ねるだけなので、
   * Figma 由来のレイアウトには一切手を入れない。 */
  var KEIKA_HEADER_LINKS = {
    "login": ["/account/login", "ログイン"],
    "cart": ["/cart", "カート"],
    "ログイン": ["/account/login", "ログイン"],
    "新規会員登録": ["/account/register", "新規会員登録"],
    "新規登録": ["/account/register", "新規登録"],
    "マイページ": ["/account", "マイページ"]
  };

  function keikaNavy(el) {
    if (!el || !el.style) return false;
    var bg = el.style.backgroundColor || "";
    return bg.replace(/\s/g, "") === "rgb(20,41,80)";
  }

  /* ボタン箱かどうか: 絶対配置で、そのラベル 1 つだけを含む箱 */
  function keikaBtnBox(s) {
    var p = s.parentElement;
    for (var i = 0; i < 2 && p; i++) {
      if (p.style && p.style.position === "absolute" && parseFloat(p.style.width)
          && (p.textContent || "").trim() === (s.textContent || "").trim()
          && p.offsetWidth > s.offsetWidth) return p;
      p = p.parentElement;
    }
    return null;
  }

  function wireHeaderLinks() {
    var spans = Array.prototype.filter.call(document.querySelectorAll("span"), function (s) {
      if (s.dataset.hdLinked) return false;
      if (s.children.length) return false;
      if (s.closest("a")) return false;                 /* 既にリンクなら触らない */
      var key = (s.textContent || "").trim().toLowerCase();
      return !!KEIKA_HEADER_LINKS[key];
    });
    spans.forEach(function (s) {
      var conf = KEIKA_HEADER_LINKS[(s.textContent || "").trim().toLowerCase()];
      /* ネイビーのボタンなら、その箱ごとリンクにする */
      var navy = keikaNavy(s.parentElement) ? s.parentElement
        : (keikaNavy(s.parentElement && s.parentElement.parentElement) ? s.parentElement.parentElement
          : keikaBtnBox(s));
      var box = navy ? (navy.offsetParent || navy.parentElement) : s.offsetParent;
      if (!box) return;                                  /* 非表示中は測れないので次回に回す */
      var target = navy || s;
      if (!target.offsetWidth || !target.offsetHeight) return;   /* 非表示中は測れないので次回に回す */
      s.dataset.hdLinked = "1";
      var l = target.offsetLeft, t = target.offsetTop;
      var r = l + target.offsetWidth, b = t + target.offsetHeight;
      if (!navy) {
        /* 同じ枠内で、ラベルの真上にあるアイコン(svg を含む要素)を取り込む */
        Array.prototype.forEach.call(box.children, function (el) {
          if (el === s || !el.querySelector || !el.querySelector("svg")) return;
          var el_l = el.offsetLeft, el_t = el.offsetTop;
          var el_r = el_l + el.offsetWidth, el_b = el_t + el.offsetHeight;
          if (Math.min(r, el_r) - Math.max(l, el_l) <= 0 || el_t > t) return;
          l = Math.min(l, el_l); t = Math.min(t, el_t);
          r = Math.max(r, el_r); b = Math.max(b, el_b);
        });
      }
      var pad = navy ? 0 : 6;
      var a = document.createElement("a");
      a.href = conf[0];
      a.setAttribute("aria-label", conf[1]);
      a.style.cssText = "position:absolute;left:" + (l - pad) + "px;top:" + (t - pad) + "px;"
        + "width:" + (r - l + pad * 2) + "px;height:" + (b - t + pad * 2) + "px;"
        + "z-index:5;cursor:pointer;background:transparent;";
      var hov = navy || box;
      hov.style.transition = "opacity .3s";
      a.addEventListener("mouseenter", function () { hov.style.opacity = "0.85"; });
      a.addEventListener("mouseleave", function () { hov.style.opacity = "1"; });
      if (getComputedStyle(box).position === "static") box.style.position = "relative";
      box.appendChild(a);

      /* 重ねたリンクが何かに覆われてもカーソルと遷移が効くよう、
       * 実際のラベル / アイコン / ボタン自体にも直接ハンドラを付ける */
      var hits = [target];
      if (!navy) {
        Array.prototype.forEach.call(box.children, function (el) {
          if (el === s || el === a || !el.querySelector || !el.querySelector("svg")) return;
          var el_l = el.offsetLeft, el_r = el_l + el.offsetWidth;
          if (Math.min(r, el_r) - Math.max(l, el_l) > 0 && el.offsetTop <= t) hits.push(el);
        });
      }
      hits.forEach(function (h) {
        h.style.cursor = "pointer";
        h.addEventListener("click", function (e) {
          e.preventDefault();
          window.location.href = conf[0];
        });
        h.addEventListener("mouseenter", function () { hov.style.opacity = "0.85"; });
        h.addEventListener("mouseleave", function () { hov.style.opacity = "1"; });
      });
    });
  }

  /* メニュー内は開くまで非表示（=位置が測れない）ため、
   * 監視は止めずに続け、表示された時点でリンクを重ねる。 */
  setInterval(wireHeaderLinks, 400);

  window.KEIKANewsPC = KEIKANewsPC;
  window.KEIKANewsSP = KEIKANewsSP;

  window.KEIKAHeaderPC = KEIKAHeaderPC;
  window.KEIKAHeaderSP = KEIKAHeaderSP;
})();
